export default "__VITE_ASSET__DBxaJdl2__"